module.exports = "/_next/static/images/OptimizeTheFirstTimeUserExperience@2x-3d7b1db41d10022744eaf8140cf386c5.png";